// CustomModal.js
import React from 'react';
import '../App.css';

const CustomModal = ({ message, onClose }) => {
  return (
    <div className="custom-modal">
      <div className="custom-modal-content">
        <span className="close-button" onClick={onClose}>&times;</span>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default CustomModal;
